// import React, { useState, useEffect } from "react";
// import Icon from "../../assets/icons/Icon";
// import Button from "./Button";
// import { isMobileView } from "./CommonFunctions";

// const CustomDrawer = ({
//   overflowYNo,
//   setDrawer,
//   title = "",
//   children,
//   footer,
//   drawerType = "medium",
//   drawerWidth,
//   buttons = [],
//   onButtonClick,
//   onClose,
//   isSideBySide
// }) => {
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     setIsVisible(true);
//   }, []);

//   const closeDrawer = () => {
 
//     if (onClose){ onClose();}
//     else{
//          setIsVisible(false);
//  setTimeout(() => {
//       setDrawer(false);
//     }, 250);
//     }
   
//   };

//   const handleButtonClick = (label) => {
//     if (onButtonClick) onButtonClick(label);
//   };

//   const widthClasses = drawerWidth
//     ? drawerWidth
//     : drawerType === "small"
//       ? "sm:min-w-[300px]"
//       : drawerType === "medium"
//         ? "sm:w-[450px]"
//         : drawerType === "large"
//           ? "w-[700px]"
//           : "sm:min-w-[430px]";

//   return (
//     <div
//       className={`fixed inset-0 z-40 bg-gray-500/45 transition-opacity duration-300 ${
//         isVisible ? "opacity-100" : "opacity-0"
//       }`}
     
//     >
//       <div
//         className={` bg-white shadow-xl fixed top-0 right-0 transform transition-transform duration-500 ease-in-out ${isMobileView() ? "w-full h-full" : `${widthClasses} h-screen` } ${
//           isVisible ? "translate-x-0" : "translate-x-full"
//         }`}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="flex flex-col h-full">
//           <div className="flex justify-between items-center py-3 text-lg border-b border-gray-300 text-[#FFFFFF] px-4 primary-gradient">
//             {/* <span className="text-left">{title}</span> */}
//             <h2 className="text-xl font-bold flex items-center">{title}</h2>
//             <span className="w-7 hover:scale-105 transition-transform duration-200 cursor-pointer" onClick={closeDrawer}>
//               <Icon type="remove" />
//             </span>
//           </div>

//           <div
//             className={`flex-1 ${
//               overflowYNo ? "" : "overflow-y-auto"
//             } ${!isSideBySide && "pt-3 pb-3 px-4" } `}
//           >
//             {children}
//           </div>

//           {footer && (
//             <div className="flex justify-between border-t border-gray-300 py-3 px-4 bg-white gap-3">
//               {footer}
//             </div>
//           )}

//           {buttons.length > 0 && (
//             <div className="flex justify-between border-t border-gray-300 py-3 px-4 bg-white gap-3">
//               {buttons.map((button, index) => (
//                 <Button
//                   key={index}
//                   type={button.Type}
//                   disabled={button.Disabled}
//                   onClick={() => handleButtonClick(button.Label)}
//                   px="px-4"
//                   iconType={button.Icon}
//                 >
//                   {button.Label}
//                 </Button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomDrawer;

import React, { useState, useEffect } from "react";
import Icon from "../../assets/icons/Icon";
import Button from "./Button";
import { isMobileView } from "./CommonFunctions";

const CustomDrawer = ({
  overflowYNo,
  setDrawer,
  title = "",
  children,
  footer,
  drawerType = "medium",
  drawerWidth,
  buttons = [],
  onButtonClick,
  onClose,
  isSideBySide
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const closeDrawer = () => {
 
    if (onClose){ onClose();}
    else{
         setIsVisible(false);
 setTimeout(() => {
      setDrawer(false);
    }, 250);
    }
   
  };

  const handleButtonClick = (label) => {
    if (onButtonClick) onButtonClick(label);
  };

  const widthClasses = drawerWidth
    ? drawerWidth
    : drawerType === "small"
      ? "sm:min-w-[300px]"
      : drawerType === "medium"
        ? "sm:w-[450px]"
        : drawerType === "large"
          ? "w-[700px]"
          : "sm:min-w-[430px]";

  return (
    <div
      className={`fixed inset-0 z-40 bg-gray-500/45 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
     
    >
      <div
        className={` bg-white shadow-xl fixed top-0 right-0 transform transition-transform duration-500 ease-in-out ${isMobileView() ? "w-full h-full" : `${widthClasses} h-screen` } ${
          isVisible ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col h-full">
          <div className="flex justify-between items-center py-3 text-lg border-b border-gray-300 text-white px-4 primary-gradient">
  
  {/* Left side */}
  {isMobileView() ? (
    <div className="flex items-center gap-2">
      <span
        className="w-7 hover:scale-105 transition-transform duration-200 cursor-pointer"
        onClick={closeDrawer}
      >
        <Icon type="back" />
      </span>
      <h2 className="text-xl font-bold">{title}</h2>
    </div>
  ) : (
    <h2 className="text-xl font-bold">{title}</h2>
  )}

  {/* Right side for desktop only */}
  {!isMobileView() && (
    <span
      className="w-7 hover:scale-105 transition-transform duration-200 cursor-pointer"
      onClick={closeDrawer}
    >
      <Icon type="remove" />
    </span>
  )}
</div>

          <div
            className={`flex-1 ${
              overflowYNo ? "" : "overflow-y-auto"
            } ${!isSideBySide && "pt-3 pb-3 px-4" } `}
          >
            {children}
          </div>

          {footer && (
            <div className="flex justify-between border-t border-gray-300 py-3 px-4 bg-white gap-3">
              {footer}
            </div>
          )}

          {buttons.length > 0 && (
            <div className="flex justify-between border-t border-gray-300 py-3 px-4 bg-white gap-3">
              {buttons.map((button, index) => (
                <Button
                  key={index}
                  type={button.Type}
                  disabled={button.Disabled}
                  onClick={() => handleButtonClick(button.Label)}
                  px="px-4"
                  iconType={button.Icon}
                >
                  {button.Label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDrawer;